import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';

const initialState = {
  RotationPlanList: [],
  RotationPlanListById: [],
  ChartRaqResultList: [],
  MyFingerPrintByDateList: [], // for person as token by date
  ResultList: [],
  ResultSummaryList: [],
  loading: false,
  error: null,
  //~~ تعيين الموظقين على الخطة
  PersonListByRotationPlan: [],
  PersonListAllRotationPlan: [],

  //~~ تقويم خطة الحضــور
  CalendarSchedules: [],
  CalendarLoading: false,
  CalendarError: null,
};

export const AddRotationPlan = createAsyncThunk(
  'Raqeeb/AddRotationPlan',
  async (item, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const { data } = await ntxAPI.post('RAQ/AddRotationPlan', item);
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const GetRotationPlan = createAsyncThunk('Raqeeb/GetRotationPlan', async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;

  try {
    const { data } = await ntxAPI.get('RAQ/GetRotationPlanList');
    return data;
  } catch (error) {
    console.log(error);
    return rejectWithValue(error.message);
  }
});

export const GetRotationPlanById = createAsyncThunk(
  'Raqeeb/GetRotationPlanById',
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const { data } = await ntxAPI.get(`RAQ/GetRotationPlanById?Id=${id}`);
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateRotationPlan = createAsyncThunk(
  'Raqeeb/UpdateRotationPlan',
  async (item, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.post('RAQ/UpdateRotationPlan', item);

      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const DeletedRotationPlan = createAsyncThunk(
  'Raqeeb/DeletedRotationPlan',
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.post(`RAQ/DeletedRotationPlan?Id=${id}`);
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const GetRaqResultByOrganization = createAsyncThunk(
  'Raqeeb/GetRaqResultByOrganization',
  // @ts-ignore
  async ({ DateFrom, DateTo }, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const { data } = await ntxAPI.get(
        `RAQ/GetRaqResultByOrganization?DateFrom=${DateFrom}&DateTo=${DateTo}`
      );
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const GetMyFingerPrintByDate = createAsyncThunk(
  'Raqeeb/GetMyFingerPrintByDate',
  // @ts-ignore
  async ({ DateFrom, DateTo }, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const { data } = await ntxAPI.get(
        `RAQ/GetMyFingerPrintByDate?DateFrom=${DateFrom}&DateTo=${DateTo}`
      );
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const GetResultList = createAsyncThunk(
  'Raqeeb/GetResultList',
  // @ts-ignore
  async ({ DateFrom, DateTo, RotationPlanId, PersonId }, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const { data } = await ntxAPI.get('RAQ/GetResultList', {
        params: {
          DateFrom,
          DateTo,
          RotationPlanId,
          PersonId,
        },
      });
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const GetResultSummaryList = createAsyncThunk(
  'Raqeeb/GetResultSummaryList',
  // @ts-ignore
  async ({ DateFrom, DateTo, RotationPlanId, PersonId }, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      // console.log('Params:', { DateFrom, DateTo, RotationPlanId, PersonId }); // للتأكد من القيم
      const { data } = await ntxAPI.get('RAQ/GetResultSummaryList', {
        params: {
          DateFrom,
          DateTo,
          RotationPlanId,
          PersonId,
        },
      });
      return data;
    } catch (error) {
      console.log('Error fetching summary list:', error);
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateAnalysis = createAsyncThunk('Raqeeb/UpdateAnalysis', async (item, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;

  try {
    const { data } = await ntxAPI.post('RAQ/AnalysisResults', item);
    return data;
  } catch (error) {
    console.log(error);
    return rejectWithValue(error.message);
  }
});

//~~~ تعيين الموظفين على خطة الحضــور
export const GetPersonListByRotationPlanId = createAsyncThunk(
  'Raqeeb/GetPersonListByRotationPlanId',
  async (rotationPlanId, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const { data } = await ntxAPI.get(`RAQ/GetPersonListByRotationPlanId`, {
        params: { RotationPlanId: rotationPlanId },
      });
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getPersonListAllRotation = createAsyncThunk(
  'Raqeeb/getPersonListAllRotation',
  async (rotationPlanId, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(`RAQ/GetPersonListByRotationPlanId`, {
        params: { RotationPlanId: rotationPlanId },
      });
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateRotationPlanPerson = createAsyncThunk(
  'Raqeeb/updateRotationPlanPerson',
  async (item, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const { data } = await ntxAPI.post('RAQ/UpdateRotationPlanPerson', item);
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

//~~~ جلب جدولة خطة الحضـــور
export const getRaqCalendarSchedules = createAsyncThunk(
  'Raqeeb/getRaqCalendarSchedules',
  async (rotationPlanId, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(`RAQ/GetRaqCalendarSchedules`, {
        params: { RotationPlanId: rotationPlanId },
      });
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

//~~~ جلب بصمات الموظفين من جدول الـ EmpTime
// export const getAllFingerPrintList = createAsyncThunk(
//   'Raqeeb/getAllFingerPrintList',
//   async (item, thunkAPI) => {
//     const { rejectWithValue } = thunkAPI;

//     try {
//       const { data } = await ntxAPI.post('RAQ/GetAllFingerPrintList', item);
//       return data;
//     } catch (error) {
//       console.log(error);
//       return rejectWithValue(error.message);
//     }
//   }
// );

export const getAllFingerPrintList = createAsyncThunk(
  'Raqeeb/getAllFingerPrintList',
  // async ({ DateFrom, DateTo, RotationPlanId, PersonId }, thunkAPI) => {
  async (item, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    // @ts-ignore
    const { DateFrom, DateTo, RotationPlanId, PersonId } = item;

    try {
      const { data } = await ntxAPI.get('RAQ/GetAllFingerPrintList', {
        params: {
          DateFrom,
          DateTo,
          RotationPlanId,
          PersonId,
        },
      });

      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

const raqeebSlice = createSlice({
  name: 'Raqeeb',
  initialState,
  reducers: {
    clearState: (state) => {
      state.ChartRaqResultList = [];
      state.ResultList = [];
      state.ResultSummaryList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Get Rotation Plan List
      .addCase(GetRotationPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetRotationPlan.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.RotationPlanList = payload;
      })
      .addCase(GetRotationPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get one Rotation plan by id
      .addCase(GetRotationPlanById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetRotationPlanById.fulfilled, (state, action) => {
        state.loading = false;
        state.RotationPlanListById = action.payload;
      })
      .addCase(GetRotationPlanById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      ///////insert
      // .addCase(AddRotationPlan.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(AddRotationPlan.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.RotationPlanList.push(action.payload);
      // })
      // .addCase(AddRotationPlan.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })

      // Edit
      // .addCase(UpdateRotationPlan.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(UpdateRotationPlan.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.RotationPlanListById = action.payload;
      // })
      // .addCase(UpdateRotationPlan.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })

      // Get GetRaqResultByOrganization
      .addCase(GetRaqResultByOrganization.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetRaqResultByOrganization.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload?.succeeded === true) {
          state.ChartRaqResultList = payload.data;
        }
      })
      .addCase(GetRaqResultByOrganization.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get GetMyFingerPrintByDate
      .addCase(GetMyFingerPrintByDate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetMyFingerPrintByDate.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload?.succeeded === true) {
          state.MyFingerPrintByDateList = payload.data;
        }
      })
      .addCase(GetMyFingerPrintByDate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get GetResultList
      // .addCase(GetResultList.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(GetResultList.fulfilled, (state, { payload }) => {
      //   state.loading = false;
      //   if (payload?.succeeded === true) {
      //     state.ResultList = payload.data;
      //   }
      // })
      // .addCase(GetResultList.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })

      // Get GetResultSummaryList
      .addCase(GetResultSummaryList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetResultSummaryList.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload?.succeeded === true) {
          state.ResultSummaryList = payload.data;
        }
      })
      .addCase(GetResultSummaryList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //~~~ تعيين الموظفين على خطة الحضــور

      .addCase(GetPersonListByRotationPlanId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetPersonListByRotationPlanId.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload?.succeeded === true) {
          state.PersonListByRotationPlan = payload.data;
        }
      })
      .addCase(GetPersonListByRotationPlanId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //~~~~~~~~~~~~~~~~~~~~~~~~`
      .addCase(getPersonListAllRotation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPersonListAllRotation.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload?.succeeded === true) {
          state.PersonListAllRotationPlan = payload.data;
        }
      })
      .addCase(getPersonListAllRotation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //~~~~~~~~~~~~~~ Calander
      .addCase(getRaqCalendarSchedules.pending, (state) => {
        state.CalendarLoading = true;
        state.CalendarError = null;
      })
      .addCase(getRaqCalendarSchedules.fulfilled, (state, { payload }) => {
        state.CalendarLoading = false;
        if (payload?.succeeded === true) {
          state.CalendarSchedules = payload.data;
        }
      })
      .addCase(getRaqCalendarSchedules.rejected, (state, action) => {
        state.CalendarLoading = false;
        state.CalendarError = action.payload;
      });
  },
});

export const { clearState } = raqeebSlice.actions;
export default raqeebSlice.reducer;
